<template>
	<div>
		<BubbleMenu v-if="editor" class="bubble-menu display-flex" :tippy-options="tippyOptions" :editor="editor">
			<div v-for="menuObj in menuItems" :key="menuObj.key" class="bubble-button flex-centerize">
				<component
					v-bind:is="menuObj.menuComponent"
					:dontShowInsertData="dontShowInsertData"
					v-bind="{ editor: editor, selectionObj: selectionObj }"
				></component>
			</div>
		</BubbleMenu>
	</div>
</template>

<script>
import { BubbleMenu } from '@tiptap/vue-2';
import { mapGetters } from 'vuex';

import RichTextMenuService from './rich-text-menu-service';
import { isConfigurationsOn } from '@/store/modules/featureFlags/getters';

export default {
	name: 'RichTextMenu',
	components: {
		BubbleMenu,
	},
	props: {
		editor: { type: Object },
		richTextFormat: { type: String },
		dontShowInsertData: { type: Boolean },
	},
	watch: {
		'editor.view.state.selection'(newV) {
			if (newV) {
				this.selectionObj = newV;
			}
		},
	},
	computed: {
		...mapGetters([isConfigurationsOn.fullPath]),
		menuItems() {
			return RichTextMenuService.getMenuItems(this.richTextFormat, this[isConfigurationsOn.fullPath]);
		},
	},
	data() {
		return {
			selectionObj: null,
			tippyOptions: { duration: 100, arrow: false, flipBehavior: ['top', 'bottom'], hideOnClick: false, showOnInit: true, sticky: true },
		};
	},
};
</script>

<style lang="scss" scoped>
.bubble-menu {
	$border-radius: 4px;
	$size: 28px;

	padding: 6px 6px;
	border-radius: $border-radius;
	background-color: var(--bg-color);

	.bubble-button {
		width: $size;
		height: $size;
		margin: 0 4px 0 0;
		border: 1px solid transparent;
		border-radius: $border-radius;
		background: none;
		color: var(--tertiary-font-color);
		font-size: 10px;
		font-weight: 500;
		opacity: 1;

		&:hover {
			cursor: pointer;
		}
		&:hover,
		&.is-active {
			opacity: 1;
			border: var(--seconday-border);
			background-color: var(--insert-data-item-selected-background);
			transition: 0.2s;
		}

		&:not(:hover),
		&:not(.is-active) {
			transition: 0.3s;
		}

		> div {
			display: flex !important;
			justify-content: center !important;
			align-items: center !important;
			height: 100%;
			width: 100%;
		}

		.v-input__slot {
			padding: 0 !important;
		}
		.v-select__selections {
			display: flex;
			align-items: center;
			justify-content: center;

			> input {
				position: absolute;
			}
		}
	}
	.menu-item-picker {
		width: $size;
		height: $size;
		border-radius: $border-radius;
		transition: 0.3s;

		&.is-active {
			background-color: #e4e4e4;
		}
	}
}

.tippy-box {
	background-color: transparent;
	box-shadow: var(--secondary-box-shadow);
	max-width: 400px !important;

	.tippy-content {
		padding: 0;
		border: none;
	}
}
</style>
